import React, { Component, Fragment } from 'react';
import '../style.css';

const tutors = [
  {
    value: 'Algebra',
    label: 'Algebra'
  },
  {
    value: 'Calculus',
    label: 'Calculus'
  },
  {
    value: 'Elementary Math',
    label: 'Elementary Math (K-7)'
  },
  {
    value: 'Geometry',
    label: 'Geometry'
  },
  {
    value: 'Pre-Calculus',
    label: 'Pre-Calculus'
  },
  {
    value: 'Statistics',
    label: 'Statistics'
  },
  {
    value: 'Trigonometry',
    label: 'Trigonometry'
  }
];

class TutorSelect extends Component {
  handleClick = (tutor) => {
    return () => {
      this.props.onSelect(tutor);
    };
  }

  render() {
    return (
      <Fragment>
        <div className="mx-auto onboard-step onboard-step--1">
          <p className="step__number">Step 1/3</p>
          <h4 className="mb-2">What topic do you need help with?</h4>
          <p className="step__description">You can change this at anytime.</p>
          <div className="mx-auto mt-4 pb-5" style={{ width: 172 }}>
            {tutors.map((tutor, index) => (
              <div
                key={index}
                className="d-flex text-left my-2 py-2 btn-cursor"
                onClick={this.handleClick(tutor.value)}
              >
                <h5 className="m-0" style={{ flex: 1, lineHeight: 1.4 }}>
                  {tutor.label}
                </h5>
                <img
                  style={{ width: 16, height: 16, marginTop: 8 }}
                  src="/assets/right-chevron.svg"
                  alt="arrow"
                />
              </div>
            ))}
          </div>
        </div>
        {/* <Footer onBack={onBack} onNext={onNext} /> */}
      </Fragment>
    );
  }
}

export default TutorSelect;



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/TutorSelect/index.js